import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { tempProjectAtom, tempTestAtom } from "../store/atoms/global/temp/tempTestId";
import { tempTestNameAtom } from "../store/atoms/global/temp/tempTestName";
import { tempTestTypeAtom } from "@store/atoms/global/temp/tempTestType";
import { tempTestUpdateIdAtom } from "@store/atoms/global/temp/tempTestUpdateId";
import { githubTokenAtom } from "@store/atoms/global/githubToken";
import { cliLoginUserKeyAtom } from "@store/atoms/global/cliToken";
import { backendRequest } from "@utils/common/backendRequest";
import { resolvePathToBackendURI } from "@utils/common/url";
import { RequestMethod } from "@types/RequestOptions";
export var useLoadTempData = function useLoadTempData() {
  var _asPath$split;

  var _useAtom = useAtom(tempTestAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      setTempTest = _useAtom2[1];

  var _useAtom3 = useAtom(tempTestNameAtom),
      _useAtom4 = _slicedToArray(_useAtom3, 2),
      setTempTestName = _useAtom4[1];

  var _useAtom5 = useAtom(tempTestTypeAtom),
      _useAtom6 = _slicedToArray(_useAtom5, 2),
      setTempTestType = _useAtom6[1];

  var _useAtom7 = useAtom(tempTestUpdateIdAtom),
      _useAtom8 = _slicedToArray(_useAtom7, 2),
      setTempTestUpdateId = _useAtom8[1];

  var _useAtom9 = useAtom(githubTokenAtom),
      _useAtom10 = _slicedToArray(_useAtom9, 2),
      setGithubToken = _useAtom10[1];

  var _useAtom11 = useAtom(cliLoginUserKeyAtom),
      _useAtom12 = _slicedToArray(_useAtom11, 2),
      setLoginKey = _useAtom12[1];

  var _useAtom13 = useAtom(tempProjectAtom),
      _useAtom14 = _slicedToArray(_useAtom13, 2),
      setProjectToRedirect = _useAtom14[1];

  var _useRouter = useRouter(),
      asPath = _useRouter.asPath;

  var queryString = (_asPath$split = asPath.split("?")) === null || _asPath$split === void 0 ? void 0 : _asPath$split[1];
  var urlQuery = new URLSearchParams(queryString);
  useEffect(function () {
    if (!urlQuery) return;
    var tempTestId = urlQuery.get("temp_test_id");
    var tempTestName = urlQuery.get("temp_test_name");
    var tempTestType = urlQuery.get("temp_test_type");
    var testId = urlQuery.get("update_test_id");
    var githubToken = urlQuery.get("github_token");
    var loginKey = urlQuery.get("lK");
    setTempTestName(tempTestName);
    setTempTest(tempTestId);
    setTempTestType(tempTestType || "save");

    if (!!urlQuery.get("project_id")) {
      setProjectToRedirect(parseInt(urlQuery.get("project_id")));
    }

    if (!!loginKey) {
      setLoginKey(loginKey);
      backendRequest(resolvePathToBackendURI("/cli/actions/login.user"), {
        method: RequestMethod.POST,
        payload: {
          loginKey: loginKey
        }
      })["catch"](function (err) {
        console.error("Request failed");
      });
    }

    if (githubToken) {
      setGithubToken(githubToken);
    }

    if (!!testId) {
      setTempTestUpdateId(testId);
    }
  }, []);
};